export enum MiniSiteContentType {
  OWNER_PROFILE = 'owner-profile',
  CONTENT_WITH_PHOTO = 'content-with-photo',
  SQUARE_FEATURE = 'square-feature',
  FULL_WIDTH_IMAGE = 'full-width-image',
  CIRCLE_FEATURE = 'circle-feature',
  HALF_HALF_IMAGES = 'half-half-images',
  TEXT_CALL_OUT = 'text-call-out',
  TEXT_BLOCK = 'text-block',
  SQUARE_TEXT_BELOW = 'square-text-below',
}

export enum MiniSiteStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

type ContentsBase = {
  id: number;
  contentTitle?: string;
};

export type OwnerProfile = {
  contentType: MiniSiteContentType.OWNER_PROFILE;
  ownerName: string;
  ownerTitle?: string;
  description: string;
  photoUrl: string;
  link?: string;
} & ContentsBase;

export type ContentWithPhoto = {
  contentType: MiniSiteContentType.CONTENT_WITH_PHOTO;
  photoPosition: 'left' | 'right';
  title: string;
  description: string;
  photoUrl: string;
  link?: string;
} & ContentsBase;

export type SquareFeature = {
  contentType: MiniSiteContentType.SQUARE_FEATURE;
  contents: {
    id: number;
    title?: string;
    subTitle?: string;
    description?: string;
    photoUrl: string;
    link?: string;
  }[];
} & ContentsBase;

export type FullWidthImage = {
  contentType: MiniSiteContentType.FULL_WIDTH_IMAGE;
  title?: string;
  subTitle?: string;
  descriptionFirst?: string;
  descriptionSecond?: string;
  photoUrl: string;
  link?: string;
} & ContentsBase;

export type CircleFeature = {
  contentType: MiniSiteContentType.CIRCLE_FEATURE;
  contents: {
    id: number;
    title?: string;
    description?: string;
    photoUrl: string;
    link?: string;
  }[];
} & ContentsBase;

export type HalfHalfImages = {
  contentType: MiniSiteContentType.HALF_HALF_IMAGES;
  contentLeft: {
    title?: string;
    subTitle?: string;
    description?: string;
    photoUrl: string;
    link?: string;
  };
  contentRight: {
    title?: string;
    subTitle?: string;
    description?: string;
    photoUrl: string;
    link?: string;
  };
} & ContentsBase;

export type TextCallOut = {
  contentType: MiniSiteContentType.TEXT_CALL_OUT;
  title: string;
  subTitle?: string;
  descriptionFirst?: string;
  descriptionSecond: string;
} & ContentsBase;

export type TextBlock = {
  contentType: MiniSiteContentType.TEXT_BLOCK;
  title?: string;
  description?: string;
  link?: string;
} & ContentsBase;

export type SquareTextBelow = {
  contentType: MiniSiteContentType.SQUARE_TEXT_BELOW;
  contents: {
    id: number;
    title?: string;
    subTitle?: string;
    description?: string;
    photoUrl: string;
    link?: string;
  }[];
} & ContentsBase;

type MiniSiteContents = {
  status: MiniSiteStatus;
  locale: string;
  previewSecret: string;
  topImageUrl: string;
  topBackgroundImageUrl: string;
  contents: Array<
    | OwnerProfile
    | ContentWithPhoto
    | SquareFeature
    | FullWidthImage
    | CircleFeature
    | HalfHalfImages
    | TextCallOut
    | TextBlock
    | SquareTextBelow
  >;
};

export default MiniSiteContents;
